import React from 'react';
import Icon from '../../../components/AppIcon';

const StatTile = ({ icon, label, value, gradient }) => {
  return (
    <div
      className="relative overflow-hidden rounded-xl p-3 flex items-center gap-3 min-h-[64px]"
      style={{ background: gradient, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
    >
      <div className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
        <Icon name={icon} size={16} color="#ffffff" />
      </div>
      <div className="min-w-0">
        <p className="text-lg font-bold text-white leading-tight tracking-tight truncate">{value}</p>
        <p className="text-[11px] text-white/80 font-medium leading-tight truncate">{label}</p>
      </div>
      <div className="absolute -right-3 -bottom-3 w-14 h-14 rounded-full bg-white/10" />
    </div>
  );
};

export default StatTile;
